import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PageSection from "components/PageSection";
import { Body2, Small, Title2Alt } from "components/Typography";
import Accordion from "components/Accordion";

const STEPS = ["application", "initialChat", "formalInterview", "decision"];

const RecruitmentProcess = () => {
    const [openStep, setOpenStep] = useState(0);
    const { t } = useTranslation("careers");

    return (
        <PageSection
            className="relative z-10 bg-white"
            containerClass="flex flex-col lg:flex-row justify-between py-16 md:pb-32 lg:py-44"
            id="careers-list"
        >
            <div className="lg:w-5/12">
                <Body2 className="fade-in-scroll uppercase text-secondary mb-4">{t("process.eyebrow")}</Body2>
                <Title2Alt className="fade-in-scroll mb-4">{t("process.title")}</Title2Alt>
                <Small className="fade-in-scroll">{t("process.body")}</Small>
            </div>

            <div className="lg:w-5/12 mt-16 lg:mt-40 fade-in-scroll">
                {STEPS.map((stepKey, index) => (
                    <Accordion
                        key={stepKey}
                        isOpen={openStep === index}
                        setIsOpen={() => setOpenStep((prev) => (prev === index ? null : index))}
                        index={String(index + 1).padStart(2, "0")}
                        title={t(`process.steps.${stepKey}.title`)}
                        open={index === 0}
                    >
                        <p>{t(`process.steps.${stepKey}.body`)}</p>
                    </Accordion>
                ))}
            </div>
        </PageSection>
    );
};

export default RecruitmentProcess;
